import { render, staticRenderFns } from "./ActionTags.vue?vue&type=template&id=51985554&scoped=true"
import script from "./ActionTags.vue?vue&type=script&lang=js"
export * from "./ActionTags.vue?vue&type=script&lang=js"
import style0 from "./ActionTags.vue?vue&type=style&index=0&id=51985554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51985554",
  null
  
)

export default component.exports